import {zoomInOnBoxWithAnimation } from '../zoom';

export function BotConnectorBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;
  let scenarios = context.scenarios ;

  
  return joint.shapes.html.AbstractBoxElementView.extend({

    isElementEditable: true,
    editElementModalController: 'editBotConnectorBoxController',
    editElementModalTemplate: require('./editBotConnectorBox.modal.html'),
    nextBotInfo: null, 

    angularTemplate: `
<div layout="column">
  <div> 
    <span> {{'parameters/quick_replies/details/graph/bot_connector_box_destination' | translate}} </span>
    <md-button ng-if="elementView.nextBotInfo" ng-click="elementView.goToScenarioButton(elementData)">
    <div class="alc-ellipsis">{{ elementView.nextBotInfo.scenarioName}}</div>
  </md-button>
  </div>
</div>
`,
initialize : function() {
  this.nextBotInfo = getDestinationScenarioButtonInfo(this.model.attributes.elementData, scenarios);
  joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
  
},

afterEditElement : function(oldElementData, newElementData) {
  this.nextBotInfo = getDestinationScenarioButtonInfo(newElementData, scenarios);
},

zoomIntoBoxInCurrentScenario : function(boxId) {
  const $myholder = $('.joint-diagram-holder');
  const el = this.model.graph.getCell(boxId);
  const elView = el.findView(this.paper);
  zoomInOnBoxWithAnimation(this.paper, $myholder, 1.15, elView.$box);
},

goToScenarioButton : function() {
  if (this.isNextBotCurrentBot(this.nextBotInfo.scenarioBoxId)) {
    this.zoomIntoBoxInCurrentScenario(this.nextBotInfo.scenarioBoxId);
  } else {
    
    if (this.nextBotInfo.scenarioFlavor == 'satisfaction-survey') {
      const state = `auth.alcmeon.fuse.parameters.account.${this.nextBotInfo.navigationMode ? "marketing-" : ""}${this.nextBotInfo.scenarioFlavor}-details`
      services.$state.go(state, {siteId: this.nextBotInfo.siteId, satisfactionSurveyId: this.nextBotInfo.satisfactionSurveyId, selectedTabIndex: 1, zoomToBoxId: this.nextBotInfo.scenarioBoxId}); 

    } else {
      const state = `auth.alcmeon.fuse.parameters.account.${this.nextBotInfo.scenarioFlavor}-details`;
      services.$state.go(state, {siteId: this.nextBotInfo.siteId, scenarioId: this.nextBotInfo.scenarioId, zoomToBoxId: this.nextBotInfo.scenarioBoxId});

    }
  }
},

isNextBotCurrentBot : function(boxId) {
  return this.model.graph.getElements().map(el => el.id).includes(boxId);
}
});
}

function getDestinationScenarioButtonInfo(elementData, scenarios) {
  let nextBotInfo = {};
  if (elementData.nextBotMetadata) {
    const splitMetadata = elementData.nextBotMetadata.split(':'); 
    if (splitMetadata.length == 5) {
      const fitleredScenarios = scenarios.filter(s => s.id == splitMetadata[3]);
      const scenario = fitleredScenarios.length ? fitleredScenarios[0] : null;
      nextBotInfo.scenarioId = splitMetadata[3];
      nextBotInfo.scenarioBoxId = splitMetadata[4];
      nextBotInfo.scenarioName = scenario ? scenario.name : 'scenario';
      nextBotInfo.scenarioFlavor = scenario? scenario.flavor: 'quick-replies';
      nextBotInfo.satisfactionSurveyId = scenario? scenario.satisfactionSurveyId: null;
      nextBotInfo.navigationMode = scenario? scenario.navigationMode: null;
      nextBotInfo.siteId = scenario? scenario.site_id: null;
    }
  } else {
    nextBotInfo = null;
  }
  return nextBotInfo;
}